export default "__VITE_PUBLIC_ASSET__966b8348__"